"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PromocodeApplied;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

function PromocodeApplied(props) {
  var promocode = props.promocode,
      onDelete = props.onDelete;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("span", null, "HoneyGuide Credits ", _react["default"].createElement("strong", null, promocode), " applied"), _react["default"].createElement("hr", null), _react["default"].createElement(_reactstrap.Button, {
    color: "primary",
    size: "sm",
    onClick: onDelete
  }, "Cancel HoneyGuide Credits"));
}